'use client';

import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

type TArg = {
  email: string;
  title: string;
};

export const useVideoLessonMutation = () => {
  return useMutation({
    mutationFn: async (data: TArg) => {
      const requestLink = `/api-v2/video-lesson`;
      return axios.post(requestLink, data);
    },
  });
};
